import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom"; // ⭐️ useLocation import karein
import { Layout, Menu } from "antd";
import {
  SettingOutlined,
  UserOutlined,
  FileDoneOutlined,
  OrderedListOutlined,
  SolutionOutlined,
  AreaChartOutlined,
  CustomerServiceOutlined,
  FileTextOutlined,
  FileSyncOutlined,
  DashboardOutlined,
  TeamOutlined,
} from "@ant-design/icons";

const { Sider } = Layout;

function Navigation() {
  let auth = localStorage.getItem("auth");
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation(); // ⭐️ current location

  // ⭐️ Map URLs to Menu keys
  const pathKeyMap = {
    "/admin/dashboard": "1",
    "/admin/admin-panel/user": "2",
    "/admin/admin-panel/directory": "3",
    "/admin/admin-panel/listing-request": "4",
    "/admin/admin-panel/category": "5",
    "/admin/admin-panel/report": "6",
    "/admin/admin-panel/admins": "31",
    // ...add more if needed
  };

  // ⭐️ Find the key for current path
  const selectedKey =
    pathKeyMap[
      Object.keys(pathKeyMap).find((path) =>
        location.pathname.startsWith(path)
      )
    ] || "1";

  function CheckSuper() {
    if (JSON.parse(auth).current.role === "super") {
      return (
        <Menu.Item key="31" icon={<TeamOutlined />} style={{ padding: "24px" }}>
          <Link to="/admin/admin-panel/admins" />
          Manage Admins
        </Menu.Item>
      );
    } else {
      return null;
    }
  }

  const onCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={onCollapse}
        style={{
          zIndex: 1000,
        }}
      >
        <div className="logo">
          <img
            src="/assets/images/logo.png"
            alt="khoja_business"
            style={{
              maxWidth: collapsed ?"65px":"130px",
              margin: "0 auto",
            }}
          />
        </div>

        <Menu
          theme="dark"
          mode="inline"
          style={{ marginTop: "40px" }}
          selectedKeys={[selectedKey]} // ⭐️ Set selectedKeys here
        >
          <Menu.Item key="1" style={{ marginBottom: "25px" }} icon={<DashboardOutlined />}>
            <Link to="/admin/dashboard" />
            Home Page
          </Menu.Item>
          <Menu.Item key="2" style={{ marginBottom: "25px" }} icon={<UserOutlined />}>
            <Link to="/admin/admin-panel/user">Users</Link>
          </Menu.Item>
          <Menu.Item key="3" style={{ marginBottom: "25px" }} icon={<FileDoneOutlined />}>
            <Link to="/admin/admin-panel/directory">Manage Business Directory</Link>
          </Menu.Item>
          <Menu.Item key="4" style={{ marginBottom: "25px" }} icon={<OrderedListOutlined />}>
            <Link to="/admin/admin-panel/listing-request">Listings Requests</Link>
          </Menu.Item>
          <Menu.Item key="5" style={{ marginBottom: "25px" }} icon={<SolutionOutlined />}>
            <Link to="/admin/admin-panel/category">Manage Categories</Link>
          </Menu.Item>
          <Menu.Item key="6" style={{ marginBottom: "25px" }} icon={<AreaChartOutlined />}>
            <Link to="/admin/admin-panel/report">Reports</Link>
          </Menu.Item>
          <CheckSuper />
        </Menu>
      </Sider>
    </>
  );
}

export default Navigation;
